export default __webpack_public_path__ + "static/media/py.7140ea7b.svg";